"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChipLabelMixin = void 0;
var _styledComponents = require("styled-components");
/** @class ChipLabelMixin */
/** @method */
var ChipLabelMixin = /*#__PURE__*/(0, _styledComponents.css)(["text-overflow:ellipsis;white-space:nowrap;overflow:hidden;"]);
exports.ChipLabelMixin = ChipLabelMixin;